<template>
    <div class="flex-row license-row">
        <LicenceItem
            v-for="license in versionedLicenses"
            :key="license.code"
            class="flex-fill-column ov-reset wp-3"
            :title="license.label"
            :code="license.code"
            :total="getTotal(license.code)"
            :value="getValue(license.code)"
            :enableSupport="enableSupport"
            :disable="!isEnable(license.code)"
        >
            {{ $l10n.__(license.description) }}
        </LicenceItem>
    </div>
</template>

<script>
import LicenceItem from 'vcomponents/sellsyaccountmanager/LicenceItem.vue';

export default {
    props: {
        licenses: {
            type: Array,
            required: true,
        },
        versionedLicenses: {
            type: Array,
            required: true,
        },
        enableSupport: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    methods: {
        license(planCode) {
            return this.licenses.find((licence) => licence.code === planCode);
        },
        isEnable(planCode) {
            const license = this.license(planCode);
            if (typeof license === 'undefined') {
                return false;
            }
            if (!this.enableSupport) {
                return license.total !== 0;
            }

            return license.available !== 0;
        },
        getTotal(planCode) {
            if (!this.isEnable(planCode)) {
                return 0;
            }
            return this.license(planCode).total;
        },
        getValue(planCode) {
            if (!this.isEnable(planCode)) {
                return 0;
            }
            const license = this.license(planCode);
            return license.total - license.available;
        },
    },
    components: {
        LicenceItem,
    },
};
</script>
<style scoped lang="scss">
.license-row {
    gap: var(--spacing-3);
}
</style>
